<template>
  <div class="row h-100">
    <div class="col-12" v-for="(card, index) in cards" :key="index">
      <div class="card card-small">
        <div
          class="card-body position-relative"
          style="padding-left: 20px !important; padding-right: 0 !important"
        >
          <div
            v-if="card.showTooltip"
            class="info"
            data-bs-toggle="tooltip"
            data-bs-placement="right"
            title="The value calculated based on schedule for this month"
          >
            i
          </div>
          <div class="widget-content">
            <div class="image">
              <img :src="require(`@/assets/images/icon/${card.img}.png`)" />
            </div>
            <div>
              <h4 class="title" v-if="card.title" v-html="titleHTML(card)"></h4>
              <span class="subtitle" >{{ card.subtitle }}</span>
              <div class="row ps-2" v-if="card.info">
                <div
                  class="col-auto px-1"
                  v-for="(item, i) in card.info"
                  :key="i"
                >
                  <h4 class="title" style="font-size: 14px">
                    <strong>{{ item.value }}</strong>
                  </h4>
                  <span class="subtitle" style="font-size: 14px">{{
                    item.label
                  }}</span>
                </div>
              </div>
              <div class="row ps-2" v-if="card.stacked">
                <div
                  class="col-auto "
                  v-for="(item, i) in card.stacked"
                  :key="i"
                >
                  <div class="row">
                    <div class="col-12">
                      <h4 class="title" style="font-size: 14px">
                        <strong>{{ item.value }}</strong>
                      </h4>
                      <span class="subtitle" style="font-size: 14px">{{
                        item.label
                      }}</span>
                    </div>
                  </div>
                </div>
                <br />
              </div>
              <br />
              <span
                class="subtitle"
                style="font-size: 13px"
                v-if="card.lastseen != ''"
                >{{ card.lastseen }}</span
              >
            </div>
          </div>
        </div>
        <div v-if="card.value" class="card-footer">
          <span @click="openLightModal">See All Streetlights >></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["cards"],
  data() {
    return {
      // cards: [
      //   {
      //     img: "connection",
      //     title: "Offline",
      //     subtitle: "Connection Status",
      //     info: [
      //       {
      //         label: "Node RSSI",
      //         value: -91,
      //       },
      //       {
      //         label: "Gateway RSSI",
      //         value: -112,
      //       },
      //     ],
      //   },
      //   {
      //     img: "bluetooth",
      //     title: "12",
      //     subtitle: "In Range Bluetooth Device",
      //   },
      //   {
      //     img: "light",
      //     title: "On",
      //     subtitle: "Light Status",
      //   },
      //   {
      //     img: "light",
      //     title: "50%",
      //     subtitle: "Light Brightness",
      //   },
      //   {
      //     img: "energy",
      //     title: "237 V",
      //     subtitle: "Last Voltage",
      //   },
      //   {
      //     img: "energy",
      //     title: "21 mA",
      //     subtitle: "Last Current",
      //   },
      // ],
    };
  },
  methods: {
    openLightModal() {
      this.$emit("open-light-modal");
    },
    titleHTML(card) {
      if (!card) return;
      if (card.img === "connection") {
        return `<span style="color: ${
          card.title === "Online" ? "#009A78" : "#FFAE2C"
        }">${card.title}</span>`;
      }
      if (!card.title.includes("{value}")) {
        return `<strong>${card.title}</strong>`;
      }
      return card.title.replace(
        "{value}",
        `<strong>${card.value}</strong>` || 0
      );
    },
  },
};
</script>
